import Utils from '../utils';

export default class CiblerAPI {
  userId;
  endpoint;
  orderEndpoint;
  customerId;
  mock;
  collectThreshold = 10000;

  constructor(endpoint, tracking, order, customerId, userId, sample) {
    this.userId = userId;
    this.endpoint = endpoint;
    this.trackEndpoint = tracking;
    this.orderEndpoint = order || endpoint;
    this.customerId = customerId;
    this.lastCollect = 0;
    this.sampleCollect = sample;
  }

  collect = (body, forceCollect) => {
    if (this.mock) {
      return;
    }
    if (forceCollect || Date.now() - this.lastCollect > this.collectThreshold) {
      if (!localStorage.getItem('ciblerSampleCollect')) {
        localStorage.setItem('ciblerSampleCollect', Math.random() * 100);
      }

      const sample = parseFloat(localStorage.getItem('ciblerSampleCollect'));

      if (sample < this.sampleCollect) {
        this.lastCollect = Date.now();
        Utils.HttpPost(`https://front.winitout.com/tr/collect/?cid=${this.customerId}`, () => {
        }, body, this.userId);
      }
    }
  };

  sendPostOrder = (orderData) => {
    if (this.mock || orderData === {}) {
      return;
    }
    Utils.HttpPost(`${this.orderEndpoint}/api/campaignBehaviors/order/${this.customerId}`, null, orderData, this.userId);
  };

  getCustomerConfiguration = (callback) => {
    if (this.mock) {
      callback();
    }
    Utils.getAjax(`${this.endpoint}/api/customers/${this.customerId}/configuration`, callback, callback, this.userId);
  };

  trackSuccessRate = (successRateId, isSuccess) => {
    Utils.getAjax(
      `${this.endpoint}/tr/successrate/${successRateId}/${isSuccess}`,
      () => undefined,
      () => undefined,
      this.userId,
    );
  }

  sessionTrack = (sessionId, type) => {
    if (!sessionId) return;

    Utils.putAjax(`${this.endpoint}/api/campaignBehaviors/session/${type}/${sessionId}`, () => false);
  };

  getGeoloc = (success, failure) => {
    Utils.getAjax(`${this.endpoint}/api/ip`, success, failure);
  }
}
